module.exports = __webpack_public_path__ + "static/media/open_type_black.0c17c09b.png";